export type ProductURLInfo  = {
    productId:string,
    businessId:string,
    isBundle:boolean,
    isVariant:boolean,


}

export const productURL = "/product-details/";
export const productURLBundleTag = "bundle";
export const productURLVariantTag = "v";

export default function GetProductInfoFromURL(url:string,multiLocationData:any,inBusiness?:string) :ProductURLInfo {
    if(!url||url.length<0){
        url = window.location.pathname;
    }


    const returnData = {productId:"",businessId:inBusiness??"",isBundle: false,isVariant:false};

    returnData.isVariant = url.includes("/"+productURLVariantTag+"/");
    let split = url.split("/").filter((x)=>x.length>0&&x!="preview");

    returnData.productId = decodeURIComponent (split.pop()??"");
    returnData.businessId = decodeURIComponent (split.pop()??"");

    return returnData;

}

export  function GenerateProductURLPrefix(inventoryId:string,brusinessId:string,isVariant:boolean,pName?:string,pBrand?:string){

    let prv = (window.location.href.endsWith("/preview")||window.location.href.endsWith("/preview/"))?"preview":"";
    let varStr = (isVariant)?"v/":"";
    let url = 'product-details/'
    if(pName&&pBrand){
       url += encodeURI(`${pBrand.replaceAll(" ","-")}/${pName.replaceAll(" ","-")}/`).replaceAll("+","-");
    }
    url += varStr  + encodeURI(brusinessId) + "/"+ encodeURI(inventoryId) + "/" + prv;
    return url;
}

export   function GetItemBundleInfoFromData(data:any){

    let maxQuantity = 999999999;
    let includedItems:string [] = []
    for(let i = 0;i<data.length;i++){
        let item = data[i];

        if(item.isTrackInventory&&item.totalQty<maxQuantity){
            maxQuantity = item.totalQty;
        }

       let desc=item.name;
        if(item.bundleQty>1)
            desc+=` x ${item.bundleQty} Qty`;

        includedItems.push(desc);
    }

    return {
        maxQuantity:maxQuantity,
        includedItems:includedItems,
    }

}
